module.exports = __webpack_public_path__ + "static/media/powersprayer.d89550a9.jpg";